import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Button,
  Row, Typography,
  Layout, Image,
  Card,
  Spin, Input,message
} from "antd";
import { useNavigate, useParams } from "react-router";
import { UPLOADS_URL, ASSESMENT } from "../../config/constants/api";
import { Get } from "../../config/api/get";
import swal from "sweetalert";
import "react-alice-carousel/lib/alice-carousel.css";
import dayjs from "dayjs";
import { BsDot } from "react-icons/bs";
import { FaArrowLeft } from "react-icons/fa";
//icons

function AssesmentDetails() {
  const {id} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const [reviews,setReviews] = useState([])
  const [ratings,setRatings] = useState({})
  const [assesment,setAssesment]= useState({})
  const days = ["Sunday","Monday",'Tuesday',"Wednesday","Thursday","Friday","Saturday"]
  const { Search } = Input;
  const [loading, setLoading] = useState(true);
  const [assesments, setAssesments] = useState([]);
  const [range, setRange] = useState([10, 200]);
  const [review, setReview] = useState({
    averageRating: 0,
    totalReviews: 0
  });
  const [rates, setRates] = useState({
    hourlyRate: 0,
    tutoringRate: 0,
    assesmentingRate: 0,
  });

  const item = { rating: 4 };

  useEffect(()=>{
    getAssesmentDetails();
    if(token){
      // getMyAssesments()
    }

  },[])


  console.log("setAssesments",assesments)


  const getMyAssesments = async (pageNumber, keyword, category) => {
    setLoading(true);
    try {
      const response = await Get(ASSESMENT.getMyAssesments,token, {
        limit: "100",
      });
      setLoading(false);
      console.log("response", response);
      if (response?.status) {
        setAssesments(response?.data?.assesments.map(item => item._id));
       
      } else {
        message.error("Something went wrong!");
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  const getAssesmentDetails = async () =>{
    try {
      const response = await Get(ASSESMENT.getAssesmentById + id,token);
      if (response?.status) {
        setAssesment(response?.data);
      } else {
        swal("Error", response?.message, "error");
       
      }
      setLoading(false);
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  }

  console.log("review",reviews);


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Row
        className="blueBackground"
        style={{
          height: "45vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography.Title
          className="fontFamily1"
          style={{
            fontSize: "30px",
            color: "#333d47",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          {<> Assesment Details</>}
        </Typography.Title>
      </Row>

      {/* section 2 */}
      <Row
        className="whiteBackground"
        style={{
          backgroundColor: "white",
          justifyContent: "center",
          padding: "50px",
        }}
        gutter={20}
      >
        <Col xs={24} md={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",

              padding: "10px",
            }}
          >
            <div style={{ marginBottom: 20, marginLeft: 10 }}>
              <FaArrowLeft
                style={{ marginRight: 8, fontSize: "20px", cursor: "pointer" }}
                onClick={() => navigate(-1)}
              />
            </div>
            <Card className="contactCard2" bordered={false}>
            {loading && <Row style={{minHeight:"30vh"}} className="flex">
              <Spin size="large" />
                </Row>}
             {!loading && <Row
                style={{
                  width: "100%",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Col xs={24} md={12}>
                <Typography.Title
                  className="fontFamily1"
                  style={{
                    fontSize: "20px",
                    fontWeight: 800,
                    color: "black",
                    textAlign: "left",
                    marginTop: 30,
                  }}
                >
                 Title
                </Typography.Title>
                <Typography.Text
                  className="fontFamily1"
                  style={{
                    fontSize: "16px",
                    color: "grey",
                    textAlign: "center",
                    justifyContent: "center",
                    textAlign:'justify'
                  }}
                >
                 {assesment?.assesment?.title}
                </Typography.Text>
                </Col>

             


                <Col xs={24} md={12}>
                <Typography.Title
                  className="fontFamily1"
                  style={{
                    fontSize: "20px",
                    fontWeight: 800,
                    color: "black",
                    textAlign: "left",
                    marginTop: 30,
                  }}
                >
                 Type
                </Typography.Title>
                <Typography.Text
                  className="fontFamily1"
                  style={{
                    fontSize: "16px",
                    color: "grey",
                    textAlign: "center",
                    justifyContent: "center",
                    textAlign:'justify'
                  }}
                >
                 {assesment?.assesment?.type || "-"}
                </Typography.Text>
                </Col>



                <Col xs={24} md={12}>
                <Typography.Title
                  className="fontFamily1"
                  style={{
                    fontSize: "20px",
                    fontWeight: 800,
                    color: "black",
                    textAlign: "left",
                    marginTop: 30,
                  }}
                >
                 Due Date
                </Typography.Title>
                <Typography.Text
                  className="fontFamily1"
                  style={{
                    fontSize: "16px",
                    color: "grey",
                    textAlign: "center",
                    justifyContent: "center",
                    textAlign:'justify'
                  }}
                >
                             {dayjs(assesment?.assesment?.dueDate).format("DD MMMM, YYYY ")}    
                </Typography.Text>
                </Col>

                <Col xs={24} md={12}>
                <Typography.Title
                  className="fontFamily1"
                  style={{
                    fontSize: "20px",
                    fontWeight: 800,
                    color: "black",
                    textAlign: "left",
                    marginTop: 30,
                  }}
                >
                 Due Time
                </Typography.Title>
                <Typography.Text
                  className="fontFamily1"
                  style={{
                    fontSize: "16px",
                    color: "grey",
                    textAlign: "center",
                    justifyContent: "center",
                    textAlign:'justify'
                  }}
                >
                   {dayjs(assesment?.assesment?.dueTime).format("HH:MM A")}    
                 {/* {assesment?.assesment?.assesmentTime} */}
                </Typography.Text>
                </Col>

                <Col xs={24} md={12}>
                <Typography.Title
                  className="fontFamily1"
                  style={{
                    fontSize: "20px",
                    fontWeight: 800,
                    color: "black",
                    textAlign: "left",
                    marginTop: 30,
                  }}
                >
                 Description
                </Typography.Title>
                <Typography.Text
                  className="fontFamily1"
                  style={{
                    fontSize: "16px",
                    color: "grey",
                    textAlign: "center",
                    justifyContent: "center",
                    textAlign:'justify'
                  }}
                >
                   {assesment?.assesment?.description}    
                </Typography.Text>
                </Col>
                   
              </Row>}
            </Card>
          </div>
        </Col>
       
      </Row>
    </Layout>
  );
}

export default AssesmentDetails;
